(function() {
    'use strict';

    angular.module( APP_ID )
        .component( 'quote', {
            bindings: {
                content:    '<'
            },
            templateUrl:  'app/views/partials/content/quote.html',
            controller:   QuoteController,
            controllerAs: 'vm',

            renderingOptions: {
                'quote': {
                    inputs:    [
                        'content="::content.asset_contents"'
                    ],
                    classes:       [ 'quote-wrap', 'block' ],
                    parentClasses: [ 'highlighted' ],
                    wrapStart:     '<div class="centraliser block__quote">',
                    wrapEnd:       '</div>'
                }
            }
        });


    function QuoteController(
        $scope,
        SubpagesService,
        TEXTS
    ){
        // Helper members.

        /** @type {angular.IController} */
        var vm = this;


        /** Explose to scope. */

        $scope._  = TEXTS.GENERIC.QUOTE;


        /** Expose to the Controller. */

        vm.parentStateId = SubpagesService.getParentState().name;
    }


    QuoteController.$inject = [ '$scope', 'SubpagesService', 'TEXTS' ];
})();
